import { History } from 'history';
import { isEqual } from 'lodash';
import { UrlParams } from 'common/types';
import {
  buildUrl,
  getUrlParams,
  setUrlParam,
  updateUrlParams,
} from 'common/util/location';
import * as K from 'common/constants';

export interface CustomLocationState {
  disposableParams?: UrlParams;
  forceUpdate?: boolean;
}

export const redirectToLocationWithTeamToken = (
  history: History,
  teamToken: string,
) => {

  const { search, pathname, hash } = history.location;

  // add teamToken
  const parametersWithTeamToken = setUrlParam(
    search,
    K.URL_PARAM.TEAM_TOKEN,
    teamToken,
  );

  history.replace({
    pathname,
    hash,
    search: parametersWithTeamToken,
  });
};

/**
 * Update query parameters in the URL.
 *
 * @param parameters    Key-value pair of what needs to be in the URL Params
 * @param replace       If true we only replace the current state. This will not create a new history record.
 * @param history       History object provided by react-router.
 * @param state         An optional state object that, if supplied, will be used as the location.state object for the history entry.
 *
 */
export const updateUrl = (parameters: UrlParams, replace: boolean, history: History, state: CustomLocationState | null) => {
  const currentUrlParams = getUrlParams(history.location.search);
  const updatedUrlParams = updateUrlParams(history.location.search, parameters);

  if (isEqual(currentUrlParams, updatedUrlParams) && !state?.forceUpdate) {
    return false;
  }

  const newUrl = buildUrl(history.location.pathname, updatedUrlParams, history.location.hash);
  if (replace) {
    history.replace(newUrl, state);
  } else {
    history.push(newUrl, state);
  }
  return true;
};

// Chrome and Safari have trouble scrolling to a named anchor in an SPA, so we check and scroll manually.
export const scrollToHash = (history: History) => {
  const hash = history.location.hash;
  if (hash) {
    setTimeout(() => {
      const anchor = document.querySelector('[name="' + hash.substring(1) + '"]');
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 1000);
  }
};
